import React from 'react';
import { ButtonProps } from 'antd';
import * as S from './styles';

interface AddButtonProps extends ButtonProps {}

export function AddButton(props: Readonly<AddButtonProps>): JSX.Element {
	return <S.AddButton {...props} />;
}
